module.exports = {
  address: "0x495A4C237CBCA5127Bdcd7393aB75F1FF046E4d6",
  abi: require("./Claim100.abi.json"),
};
